var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.45H5.2M6.3 8.65H5.2M9.6 4.25H5.2M11.8 4.14V9.86C11.8 10.7841 11.8 11.2461 11.6202 11.5991C11.462 11.9096 11.2096 12.162 10.8991 12.3202C10.5461 12.5 10.0841 12.5 9.16 12.5H5.64C4.71591 12.5 4.25387 12.5 3.90092 12.3202C3.59045 12.162 3.33803 11.9096 3.17984 11.5991C3 11.2461 3 10.7841 3 9.86V4.14C3 3.21591 3 2.75387 3.17984 2.40092C3.33803 2.09045 3.59045 1.83803 3.90092 1.67984C4.25387 1.5 4.71591 1.5 5.64 1.5H9.16C10.0841 1.5 10.5461 1.5 10.8991 1.67984C11.2096 1.83803 11.462 2.09045 11.6202 2.40092C11.8 2.75387 11.8 3.21591 11.8 4.14Z",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.11a938489c004ab4b7f3d9da4ae0c222.svg";
export { ForwardRef as ReactComponent };